import VerbacallIcon from "../../../assets/svg/verbacall-icon";
import VerbachatIcon from "../../../assets/svg/verbachat-icon";
import VerbafloLogoIcon from "../../../assets/images/verbaflo-logo.png";
import VerbamailIcon from "../../../assets/svg/verbamail-icon";
import VerbamessengerIcon from "../../../assets/svg/verbamessenger-icon";
import { Lead as ReduxLead, Message, Ticket } from "../utils/types";
import { formatLargeDisplayNumbers } from "../../../utils/functions/formatters";
import { WORKFLO_NAME } from "../../../utils/constants/globalConstants";
import MentionsIcon from "../../../assets/svg/mentions-icon";
import VerbasmsIcon from "../../../assets/svg/verbasms-icon";
import FbMessengerIcon from "../../../assets/svg/fb-messenger-icon";
import InstagramIcon from "../../../assets/svg/instagram-icon";

interface Campaign {
  name: string;
  id: string;
}

interface TransformedCampaign {
  label: string;
  value: string;
  content: JSX.Element;
}

export const COMMUNICATION_VIEWS_OPTIONS = [
  {
    value: "inbox",
    content: (
      <span className="text-md font-medium text-heading-text dark:text-heading-text-dk">
        Inbox
      </span>
    ),
    selectedOptionContent: (
      <span className="text-xl font-semibold text-verba-indigo dark:text-verba-indigo-dk">
        Inbox
      </span>
    ),
  },
  {
    value: "analytics",
    content: (
      <span className="text-md font-medium text-heading-text dark:text-heading-text-dk">
        Analytics
      </span>
    ),
    selectedOptionContent: (
      <span className="text-xl font-semibold text-verba-indigo dark:text-verba-indigo-dk">
        Analytics
      </span>
    ),
  },
];

export const COMMUNICATION_MODALITIES_OPTIONS = [
  {
    value: "all",
    content: (
      <div className="flex items-center gap-[10px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[18px] h-[18px]"
        />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            All Channels
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All modes of communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[14px] h-[14px]"
        />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          All Channels
        </h3>
      </div>
    ),
  },

  {
    value: "widget",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbachatIcon className="w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaChat
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Chat communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbachatIcon className="w-[14px] h-[14px] text-verba-chat dark:text-verba-chat-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaChat
        </h3>
      </div>
    ),
  },
  {
    value: "email",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamailIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMail
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            E-Mail communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamailIcon className="w-[14px] h-[14px] text-verba-mail dark:text-verba-mail-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMail
        </h3>
      </div>
    ),
  },
  {
    value: "whatsapp",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMessenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            WhatsApp communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamessengerIcon className="w-[14px] h-[14px] text-verba-messenger dark:text-verba-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMessenger
        </h3>
      </div>
    ),
  },
  {
    value: "call",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaCall
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Call communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbacallIcon className="w-[14px] h-[14px] text-verba-lavender dark:text-verba-lavender-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaCall
        </h3>
      </div>
    ),
  },
  {
    value: "sms",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbasmsIcon className="w-[18px] h-[18px] text-verba-sms dark:text-verba-sms-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaSMS
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            SMS Messaging communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbasmsIcon className="w-[14px] h-[14px] text-verba-sms dark:text-verba-sms-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaSMS
        </h3>
      </div>
    ),
  },
  {
    value: "fb_messenger",
    content: (
      <div className="flex items-center gap-[10px]">
        <FbMessengerIcon className="w-[18px] h-[18px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Facebook Messenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All messenger communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <FbMessengerIcon className="w-[14px] h-[14px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Facebook Messenger
        </h3>
      </div>
    ),
  },
  {
    value: "instagram",
    content: (
      <div className="flex items-center gap-[10px]">
        <InstagramIcon className="w-[18px] h-[18px]" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Instagram DMs
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All Instagram communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <InstagramIcon className="w-[14px] h-[14px]" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Instagram DMs
        </h3>
      </div>
    ),
  },
];

export const COMMUNICATION_FILTER_MODALITIES_OPTIONS = [
  {
    value: "all",
    content: (
      <div className="flex items-center gap-[10px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[18px] h-[18px]"
        />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            All Channels
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All Modes of communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[14px] h-[14px]"
        />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          All Channels
        </h3>
      </div>
    ),
  },
  {
    value: "widget",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbachatIcon className="w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaChat
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Chat widget communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbachatIcon className="w-[14px] h-[14px] text-verba-chat dark:text-verba-chat-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaChat
        </h3>
      </div>
    ),
  },
  {
    value: "email",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamailIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMail
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            E-Mail communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamailIcon className="w-[14px] h-[14px] text-verba-mail dark:text-verba-mail-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMail
        </h3>
      </div>
    ),
  },
  {
    value: "whatsapp",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMessenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All WhatsApp communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamessengerIcon className="w-[14px] h-[14px] text-verba-messenger dark:text-verba-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMessenger
        </h3>
      </div>
    ),
  },
  {
    value: "call",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaCall
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Call communication with leads
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbacallIcon className="w-[14px] h-[14px] text-verba-lavender dark:text-verba-lavender-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaCall
        </h3>
      </div>
    ),
  },
  {
    value: "sms",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbasmsIcon className="w-[18px] h-[18px] text-verba-sms dark:text-verba-sms-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaSMS
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            SMS communication with leads
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbasmsIcon className="w-[14px] h-[14px] text-verba-sms dark:text-verba-sms-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaSMS
        </h3>
      </div>
    ),
  },
  {
    value: "fb_messenger",
    content: (
      <div className="flex items-center gap-[10px]">
        <FbMessengerIcon className="w-[18px] h-[18px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Facebook Messenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All messenger communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <FbMessengerIcon className="w-[14px] h-[14px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Facebook Messenger
        </h3>
      </div>
    ),
  },
  {
    value: "instagram",
    content: (
      <div className="flex items-center gap-[10px]">
        <InstagramIcon className="w-[18px] h-[18px]" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Instagram DMs
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All Instagram communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <InstagramIcon className="w-[14px] h-[14px]" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Instagram DMs
        </h3>
      </div>
    ),
  },
];

export const COMMUNICATION_CAMPAIGN_MODALITIES_OPTIONS = [
  {
    value: "all",
    content: (
      <div className="flex items-center gap-[10px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[18px] h-[18px]"
        />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            All Channels
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All modes of communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <img
          src={VerbafloLogoIcon}
          alt="Verbaflo Logo"
          className="w-[14px] h-[14px]"
        />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          All Channels
        </h3>
      </div>
    ),
  },
  {
    value: "email",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamailIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMail
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            E-Mail communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamailIcon className="w-[14px] h-[14px] text-verba-mail dark:text-verba-mail-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMail
        </h3>
      </div>
    ),
  },
  {
    value: "whatsapp",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMessenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            WhatsApp communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamessengerIcon className="w-[14px] h-[14px] text-verba-messenger dark:text-verba-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMessenger
        </h3>
      </div>
    ),
  },
  {
    value: "call",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaCall
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Call communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbacallIcon className="w-[14px] h-[14px] text-verba-lavender dark:text-verba-lavender-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaCall
        </h3>
      </div>
    ),
  },
];

export const COMMUNICATION_INBOX_MODALITIES_OPTIONS = [
  {
    value: "widget",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbachatIcon className="w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaChat
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Chat communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <VerbachatIcon className="w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          VerbaChat
        </h3>
      </div>
    ),
  },
  {
    value: "email",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamailIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMail
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            E-Mail communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <VerbamailIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMail
        </h3>
      </div>
    ),
  },
  {
    value: "whatsapp",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMessenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            WhatsApp communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMessenger
        </h3>
      </div>
    ),
  },
  {
    value: "call",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaCall
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Call communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          VerbaCall
        </h3>
      </div>
    ),
  },
  {
    value: "sms",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbasmsIcon className="w-[18px] h-[18px] text-verba-sms dark:text-verba-sms-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaSMS
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            SMS Messaging communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <VerbasmsIcon className="w-[18px] h-[18px] text-verba-sms dark:text-verba-sms-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          VerbaSMS
        </h3>
      </div>
    ),
  },
  {
    value: "fb_messenger",
    content: (
      <div className="flex items-center gap-[10px]">
        <FbMessengerIcon className="w-[18px] h-[18px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Facebook Messenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All messenger communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <FbMessengerIcon className="w-[18px] h-[18px] text-verba-fb-messenger dark:text-verba-fb-messenger-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Facebook Messenger
        </h3>
      </div>
    ),
  },
  {
    value: "instagram",
    content: (
      <div className="flex items-center gap-[10px]">
        <InstagramIcon className="w-[18px] h-[18px]" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Instagram DMs
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            All Instagram communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <InstagramIcon className="w-[18px] h-[18px]" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Instagram DMs
        </h3>
      </div>
    ),
  },
  {
    value: "mentions",
    content: (
      <div className="flex items-center gap-[10px]">
        <MentionsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Mentions
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Internal team communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[6px]">
        <MentionsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Mentions
        </h3>
      </div>
    ),
  },
];

export const CONVERSATION_VIEWS_OPTIONS = [
  {
    value: "all_chats",
    content: (
      <div className="flex items-center gap-[4px]">
        <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          All Chats
        </p>
        <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
          (57 chats)
        </span>
      </div>
    ),
    selectedOptionContent: (
      <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        All Chats
      </p>
    ),
  },
  {
    value: "leads_created",
    content: (
      <div className="flex items-center gap-[4px]">
        <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Leads Interacted
        </p>
        <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
          (23 chats)
        </span>
      </div>
    ),
    selectedOptionContent: (
      <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        Leads Interacted
      </p>
    ),
  },
  {
    value: "human_involved",
    content: (
      <div className="flex items-center gap-[4px]">
        <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Human Assisted
        </p>
        <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
          (12 chats)
        </span>
      </div>
    ),
    selectedOptionContent: (
      <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        Human Assisted
      </p>
    ),
  },
  {
    value: "customer-queries",
    content: (
      <div className="flex items-center gap-[4px]">
        <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Customer Queries
        </p>
        <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
          (34 chats)
        </span>
      </div>
    ),
    selectedOptionContent: (
      <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        Customer Queries
      </p>
    ),
  },
  {
    value: "anonymous",
    content: (
      <div className="flex items-center gap-[4px]">
        <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
          Anonymous
        </p>
        <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
          (8 chats)
        </span>
      </div>
    ),
    selectedOptionContent: (
      <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
        Anonymous
      </p>
    ),
  },
];

export const COMMUNICATION_DETAILS_TABS = [
  {
    id: "lead_details",
    label: "Lead Details",
  },
  {
    id: "campaigns",
    label: `${WORKFLO_NAME.plural}`,
  },
  {
    id: "timeline",
    label: "Timeline",
  },
];

export const getChannelFromPath = (pathname: string) => {
  if (pathname.includes("/verbachat")) return "widget";
  if (pathname.includes("/verbacall")) return "call";
  if (pathname.includes("/verbamail")) return "email";
  if (pathname.includes("/verbamessenger")) return "whatsapp";
  if (pathname.includes("/verbasms")) return "sms";
  if (pathname.includes("/fbmessenger")) return "fb_messenger";
  if (pathname.includes("/instagram")) return "instagram";
  return "all";
};

export const getRouteFromModality = (modality: string, campaignId?: string) => {
  switch (modality) {
    case "widget":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/verbachat`
        : "/dashboard/communications/inbox/verbachat";
    case "call":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/verbacall`
        : "/dashboard/communications/inbox/verbacall";
    case "sms":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/verbasms`
        : "/dashboard/communications/inbox/verbasms";
    case "email":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/verbamail`
        : "/dashboard/communications/inbox/verbamail";
    case "whatsapp":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/verbamessenger`
        : "/dashboard/communications/inbox/verbamessenger";
    case "fb_messenger":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/fbmessenger`
        : "/dashboard/communications/inbox/fbmessenger";
    case "instagram":
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/instagram`
        : "/dashboard/communications/inbox/instagram";
    case "all":
    default:
      return campaignId
        ? `/dashboard/campaigns/${campaignId}/communications/all`
        : "/dashboard/communications/inbox";
  }
};

export const ALLOWED_ATTACHMENT_TYPES = {
  images: ["image/jpeg", "image/png"],
  pdfs: ["application/pdf"],
  text: [
    "text/plain",
    "text/csv",
    "application/csv",
    "text/tab-separated-values",
  ],
  docs: [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  sheets: [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],
  presentations: [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ],
};

export const transformMessage = (
  message: Message,
  channel?: string,
  message_details?: Ticket,
  nylas_thread_id?: string | null
): Omit<Message, keyof Message> & Message => ({
  id: message.message_id,
  message_id: message.message_id,
  secondary_id: message?.secondary_id,
  content: message.content,
  transcript_text: message.transcript_text,
  role: message.role,
  kind: (message.kind === "chat" ||
  message.kind === "nudge" ||
  message.kind === "mention" ||
  message.kind === "ticket"
    ? message.kind
    : "chat") as "chat" | "nudge" | "mention" | "ticket",
  timestamp: message.timestamp,
  language: message.language,
  attachments: message.attachments,
  template_meta_data: message.template_meta_data,
  channel: channel || message.channel,
  translated_content: message.translated_content,
  cc: message.cc,
  bcc: message.bcc,
  bot_version: message.bot_version,
  property_json: message.property_json,
  agent_name: message.agent_name,
  agent_id: message.agent_id,
  quick_replies: message.quick_replies,
  mongo_chunk_ids: message.mongo_chunk_ids,
  is_message_too_long: message.is_message_too_long,
  end_of_conversation: message.end_of_conversation,
  campaign_metadata: message.campaign_metadata,
  subject: message.subject,
  template_content: message.template_content,
  media_type: message.media_type,
  media_expiry_time: message.media_expiry_time,
  wati_message_id: message.wati_message_id,
  is_template_message: message.is_template_message,
  status: message.status,
  status_history: message.status_history || null,
  aiResponseTime: message.ai_response_time_in_seconds || 0,
  flagged_metadata: message.flagged_metadata,
  message_details: message_details || message.message_details,
  nylas_thread_id: nylas_thread_id ?? message.nylas_thread_id,
});

export const transformCampaign = (campaign: Campaign): TransformedCampaign => ({
  label: campaign.name,
  value: campaign.id,
  content: (
    <div className="flex items-center gap-2">
      <p className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        {campaign.name}
      </p>
    </div>
  ),
});

export const transformLead = (lead: ReduxLead): ReduxLead => ({
  ...lead,
  leadId: lead.lead_id,
  leadName: lead?.name || "Anonymous",
  isOnline:
    lead.is_online_on_whatsapp ||
    lead.is_online_on_widget ||
    lead.is_online_on_fb_messenger ||
    lead.is_online_on_instagram,
  is_online:
    lead.is_online_on_whatsapp ||
    lead.is_online_on_widget ||
    lead.is_online_on_fb_messenger ||
    lead.is_online_on_instagram,
  inboundModalities: lead.channel_tracking || {},
  outboundModalities: lead.outbound_channel_tracking || {},
  isHumanAssisted: lead.agent_override,
  sourceCountry: lead.source_country_alpha2,
  latestMessage: lead.latest_chat,
  sessionCount: lead?.session_count || 0,
  messageCount: lead?.message_body_count || 0,
  hasFeedback: lead?.feedback?.average_score || 0,
  timestamp: lead?.latest_chat_timestamp,
  feedback: lead?.feedback || { average_score: 0 },
  isSecondaryLead: lead.original_lead_id ? true : false,
});

export const computeAvailableInboxModalities = (
  currentLead: {
    is_online_on_widget?: boolean;
    is_online_on_whatsapp?: boolean;
    is_online_on_fb_messenger?: boolean;
    is_online_on_instagram?: boolean;
  } | null,
  leadDetails: {
    email?: string | null;
    phone?: string | null;
    sms?: string | null;
  } | null
) => {
  const priorityOrder = [
    "widget",
    "whatsapp",
    "sms",
    "fb_messenger",
    "instagram",
    "call",
    "email",
    "mentions",
  ];
  return COMMUNICATION_INBOX_MODALITIES_OPTIONS.filter((option) => {
    switch (option.value) {
      case "widget":
        return !!currentLead?.is_online_on_widget;
      case "whatsapp":
        return !!currentLead?.is_online_on_whatsapp;
      case "sms":
        return !!(leadDetails?.phone && leadDetails.phone.trim() !== "");
      case "fb_messenger":
        return !!currentLead?.is_online_on_fb_messenger;
      case "instagram":
        return !!currentLead?.is_online_on_instagram;
      case "call":
        return !!(leadDetails?.phone && leadDetails.phone.trim() !== "");
      case "email":
        return !!(leadDetails?.email && leadDetails.email.trim() !== "");
      case "mentions":
        return true;
      default:
        return false;
    }
  })?.sort((a, b) => {
    const aIndex = priorityOrder?.indexOf(a.value);
    const bIndex = priorityOrder?.indexOf(b.value);
    return aIndex - bIndex;
  });
};

export const getConversationFilterOptions = (inbox: {
  summary: { id: string; name: string; count: number }[];
}) => {
  if (!inbox?.summary) return [];

  return inbox?.summary?.map(
    (item: { id: string; name: string; count: number }) => ({
      value: item?.id,
      content: (
        <div className="flex items-center gap-[4px]">
          <p className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            {item.name}
          </p>
          <span className="text-xxs font-normal text-dark-gray dark:text-dark-gray-dk">
            ({formatLargeDisplayNumbers(item?.count)})
          </span>
        </div>
      ),
      selectedOptionContent: (
        <p className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
          {item?.name}
        </p>
      ),
    })
  );
};

export const getCurrentDateInSelectedRange = (
  msgDate: string,
  dateRef: { startDate: string; endDate: string }
) => {
  const messageDate = msgDate ? new Date(msgDate) : new Date();
  const startDate = new Date(dateRef.startDate);
  const endDate = new Date(dateRef.endDate);

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  const isInRange = messageDate >= startDate && messageDate <= endDate;

  return isInRange;
};

export const COMMUNICATION_CONFIG = {
  CAMPAIGN_TITLE: `${WORKFLO_NAME.singular} Communications`,
  EMPTY_STATE: {
    LOADING: "Loading...",
    LEADS: "No leads found",
    MESSAGES: "No messages available",
    LEAD_DETAILS: "No lead details available",
    CAMPAIGNS: `No ${WORKFLO_NAME.singular} available`,
    TIMELINE: "No timeline activity available",
    SELECT_LEAD: "Select a lead to view details",
  },
  SUCCESS_MESSAGES: {
    LEAD_DELETED: "Lead deleted successfully",
    LEAD_DETAILS_UPDATED: "Lead details updated successfully",
    CUSTOM_QA_ADDED: "Custom Q&A added successfully",
    SOURCE_UPDATED: "Source updated successfully",
    DOCUMENT_DOWNLOADED: "Document downloaded successfully",
    DOCUMENT_REINGESTED: "Document reingested successfully",
  },
  ERROR_MESSAGES: {
    LEAD_DELETED: "Failed to delete lead",
    LEAD_DETAILS_UPDATED: "Failed to update lead details",
    CUSTOM_QA_ADDED: "Failed to add custom Q&A",
    SOURCE_UPDATED: "Failed to update source",
    DOCUMENT_DOWNLOADED: "Failed to download document",
    DOCUMENT_REINGESTED: "Failed to reingest document",
  },
  PLACEHOLDERS: {
    LEAD_SEARCH: "Search by lead id, name, email or phone",
  },
};

export const transformTicketData = (tickets: Ticket[]) => {
  return tickets.map((ticket) => ({
    ticketId: ticket.api_response.result.ticket_id,
    messageId: ticket._id || ticket?.id,
    modality: ticket.channel,
    subject: ticket.request_sent.subject,
    category: ticket.request_sent.category,
    priority: ticket.request_sent.priority,
    createdBy: ticket.request_sent.student_name,
    description: ticket.request_sent.description,
  }));
};
